import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import {
    ModalNext,
    ModalHeader,
    ModalBody,
} from '@jutro/components';
import { Button } from '@jutro/legacy/components';

const CORVEL_SSO_URL = window.location.hostname === 'ceuat.copperpoint.com'
    ? 'http://www.caremc.com/sso/cpuatokta'
    : 'http://www.caremc.com/sso/cpokta';
const CORVEL_ACCESS_REQUEST_URL = 'https://www.copperpoint.com/corvel-portal-access-request';
const CONTACT_FORM_URL = 'https://www.copperpoint.com/contact-form';

const BTN_NAVY = {
    minWidth: '145px',
    color: 'white',
    backgroundColor: '#1e3a5f',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'bold',
};

function CorVelClaimsModal(props) {
    const { isOpen, onReject } = props;

    const handleAccessCorVel = useCallback(() => {
        window.open(CORVEL_SSO_URL, '_blank');
    }, []);

    const handleRequestAccess = useCallback(() => {
        window.open(CORVEL_ACCESS_REQUEST_URL, '_blank');
    }, []);

    const handleClose = useCallback(() => {
        onReject();
    }, [onReject]);

    return (
        <ModalNext isOpen={isOpen} className="modalClass">
            <div style={{ background: '#f5861f', borderRadius: '2px' }} />
            <div style={{ color: '#c1531b' }}><ModalHeader title="CorVel Claims Information" /></div>
            <ModalBody>
                <p>
                    CopperPoint Insurance partners with CorVel as our Third Party Administrator (TPA)
                    to administer claims in specific states. Examples of such claims are those claims
                    showing in the Portal with &ldquo;TBD&rdquo; as their claim number.
                </p>
                <br />
                <p>
                    If you already have access to the CorVel system, please select Access CorVel
                    button below to be taken directly into their system.
                </p>
                <br />
                <p>
                    If you have a claim being administered by CorVel and require access to the CorVel
                    system, please select the Request Access to CorVel button below.
                </p>
                <br />
                <p>
                    If you are unsure if CorVel is being used to administer claims on your policy,
                    please reach out to your agent/broker or contact us at{' '}
                    <a href={CONTACT_FORM_URL} target="_blank" rel="noreferrer">
                        www.copperpoint.com/contact-form
                    </a>
                    .
                </p>
                <br />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <button type="button" onClick={handleAccessCorVel} style={{ ...BTN_NAVY, padding: '0.5rem 1rem' }}>
                        Access CorVel
                    </button>
                    <Button onClick={handleRequestAccess} className="fileClaimsButton" style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        Request Access<br />to CorVel
                    </Button>
                </div>
            </ModalBody>
            <div style={{ background: '#ebebeb', borderTop: '1px solid orange', display: 'flex', justifyContent: 'flex-end', padding: '1rem' }}>
                <Button onClick={handleClose} style={{ minWidth: '145px' }}>
                    Close
                </Button>
            </div>
        </ModalNext>
    );
}

// isOpen and onReject are not passed explicitly — Jutro's showModal() injects them automatically.
// Same pattern used by CEsubscriptionLossRunModal in this directory.
CorVelClaimsModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onReject: PropTypes.func.isRequired,
};

export default CorVelClaimsModal;
